import { useContext, useEffect } from 'react';
import { LoadableComponentContext } from '../../utils/hooks/useLoadableComponent';
import { CommentEditorSource } from '../redux/types';
import { EditorContext } from '../context';
/**
 * Forces our DaEditor chunk to load if this editor needs it to.
 *
 * Relies on the `EditorContext` and `LoadableComponentContext`.
 *
 * Some examples of when we'd want it to:
 * 1. A user clicked on a reply somewhere that doesn't have a comment editor mounted already.
 * 2. We're loading a draft.
 * 3. Even more situations!
 */
export function useForceLoadIfNeeded(editorSource, isFocusRequested, hasInitialContent) {
    var isEditorReady = useContext(EditorContext).isReady;
    var triggerEditorLoad = useContext(LoadableComponentContext).triggerLoad;
    // Handle on-mount loading of the editor component when focus is requested, initial content is provided,
    // or this comment box is for a reply.
    useEffect(function () {
        var forceLoadOnMount = hasInitialContent ||
            editorSource === CommentEditorSource.Reply ||
            isFocusRequested ||
            (isFocusRequested && isEditorReady);
        if (forceLoadOnMount) {
            triggerEditorLoad();
        }
    }, [triggerEditorLoad, editorSource, isFocusRequested, isEditorReady]);
}
//# sourceMappingURL=useForceLoadIfNeeded.js.map